import {useSuspenseQuery} from '@tanstack/react-query';
import {categorySchema} from 'shared';

import {api} from '@/lib/ky';

import {categoryKeys} from './queryKeys';

import type {
  ExtractFnReturnType,
  QueryConfig,
  QueryConfig2,
} from '@/lib/react-query';

export const getCategory = async (id: string) => {
  const data = await api.get(`categories/${id}`).json();
  return categorySchema.parse(data);
};

export const useCategory = (id: string, config?: QueryConfig<QueryFnType>) => {
  return useSuspenseQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: categoryKeys.detail(id),
    queryFn: () => getCategory(id),
  });
};
export const useCategoryLoader = (config: QueryConfig2<QueryFnType>) => {
  return useSuspenseQuery<ExtractFnReturnType<QueryFnType>>(config);
};

type QueryFnType = typeof getCategory;
